{
  "title": "Users",
  "list_title": "Users",
  "subtitle": "Who can sign in — admins manage accounts and roles",
  "no_users": "No users",
  "you_marker": "(you)",
  "role": {
    "admin": "Admin",
    "user": "User"
  },
  "fields": {
    "username": "Username",
    "password": "Password",
    "role": "Role"
  },
  "actions": {
    "new": "New user",
    "edit": "Edit",
    "change_password": "Change password",
    "delete": "Delete",
    "delete_confirm": "Really delete user \"{{name}}\"?\n\nIncluding all assigned agents."
  },
  "errors": {
    "self_delete": "You cannot delete yourself.",
    "username_exists": "Username already exists."
  },
  "new_dialog": {
    "title": "Create new user",
    "username_placeholder": "e.g. alice"
  },
  "password_dialog": {
    "title": "Change password: {{name}}",
    "new_password_label": "New password",
    "min_length_hint": "At least 8 characters"
  },
  "edit_dialog": {
    "title": "Edit user: {{name}}"
  },
  "apikeys": {
    "title": "API Keys",
    "subtitle": "Long-lived tokens for external access (MCP, scripts) — no login required",
    "name_placeholder": "e.g. claude-code-local",
    "create": "Create key",
    "save_now": "Save this key now — it will only be shown once:",
    "copy": "Copy",
    "copied": "Copied!",
    "dismiss": "Dismiss",
    "delete_confirm": "Really revoke this API key?",
    "empty": "No API keys yet.",
    "own_title": "My API keys",
    "own_subtitle": "For scripts, apps and your agents' credential profiles. A key has your permissions, do not share it. Creating and deleting only works here with your login.",
    "loading": "Loading API keys …"
  }
}
